// packages/app/src/components/solutions-agent/types.ts

export type PipelineStepId =
  | 'digest'
  | 'research'
  | 'knowledge'
  | 'clarify'
  | 'analyze'
  | 'redteam'
  | 'harden'
  | 'ui'
  | 'review'
  | 'complete';

export const PIPELINE_STEPS: { id: PipelineStepId; label: string }[] = [
  { id: 'digest', label: 'Digest' },
  { id: 'research', label: 'Research' },
  { id: 'knowledge', label: 'Knowledge' },
  { id: 'clarify', label: 'Clarify' },
  { id: 'analyze', label: 'Analyze' },
  { id: 'redteam', label: 'Red team' },
  { id: 'harden', label: 'Harden' },
  { id: 'ui', label: 'UI' },
  { id: 'review', label: 'Review' },
  { id: 'complete', label: 'Done' },
];

export type ChatRole = 'user' | 'assistant' | 'system';

export interface ChatMessage {
  id: string;
  role: ChatRole;
  text: string;
  at: string;
}

export interface RunStatus {
  runId: string;
  slug?: string;
  status?: string;
  phase?: string;
  questions?: string[];
  proposalUrl?: string;
  proposalKey?: string;
  zipUrl?: string;
  zipKey?: string;
  createdAt?: string;
  updatedAt?: string;
  completedAt?: string;
  run?: {
    url?: string;
    notes?: string;
    mockLlm?: boolean;
    prefix?: string;
  };
  error?: string;
}

export interface StartRunResponse {
  runId: string;
  slug?: string;
  mockLlm?: boolean;
  message?: string;
  executionArn?: string;
  error?: string;
}

/** Map coarse API status/phase onto the step list without inventing unseen phases. */
export function resolveActiveStep(item: RunStatus | null): PipelineStepId | null {
  if (!item) return null;
  if (item.status === 'complete' || item.phase === 'complete') return 'complete';

  const phase = (item.phase ?? '').toLowerCase();
  const known = PIPELINE_STEPS.find(s => s.id === phase);
  if (known) return known.id;

  const status = (item.status ?? '').toLowerCase();
  if (status === 'clarify' || status === 'started') {
    return status === 'clarify' ? 'clarify' : 'digest';
  }
  if (status === 'clarify_resumed') return 'analyze';
  if (status === 'review') return 'review';
  if (status === 'review_resumed') return 'ui';
  return null;
}

export function stepIndex(id: PipelineStepId | null): number {
  if (!id) return -1;
  return PIPELINE_STEPS.findIndex(s => s.id === id);
}
